import { IQuestionListItem } from '@/types';
import { message, Modal } from 'antd';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

// 赋值链接到剪贴板方法
export const copyMethod = (link: string, cb?: () => void) => {
    const oInput = document.createElement('input');
    oInput.value = link;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象
    document.execCommand('Copy'); // 执行浏览器复制命令
    oInput.className = 'oInput';
    oInput.style.display = 'none';
    document.body.removeChild(oInput);
    cb && cb();
};

// 生成随机数
export const uuid = (len?: any, radix?: any, chars?: any) => {
    const newChars = (chars || '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz').split('');
    const $uuid = [];
    let i;
    const newRadix = radix || newChars.length;

    if (len) {
        for (i = 0; i < len; i++) {
            $uuid[i] = newChars[0 | (Math.random() * newRadix)];
        }
    } else {
        let r;
        $uuid[8] = $uuid[13] = $uuid[18] = $uuid[23] = '-';
        $uuid[14] = '4';
        for (i = 0; i < 36; i++) {
            if (!$uuid[i]) {
                r = 0 | (Math.random() * 16);
                $uuid[i] = newChars[i === 19 ? (r & 0x3) | 0x8 : r];
            }
        }
    }

    return $uuid.join('');
};

/**
 * 判断next环境
 */
export const getBaseUrl = () => {
    if (window.__POWERED_BY_QIANKUN__) {
        if (window.qiankunOptions?.baseUrl) {
            return window.qiankunOptions?.baseUrl;
        } else if (location.href.includes('/sub-tiku')) {
            return '/sub-tiku';
        }
        return '/';
    }
    return '/';
};

/**
 * 时间转化时分秒
 * @param time 时间
 * @param type 时间当前的格式 默认是秒
 * @returns 时间的字符串
 */
export const transformDurationTime = (time: any, type?: duration.DurationUnitType) => {
    if (!time) {
        return '0秒';
    }
    const date = dayjs.duration(time, type || 'seconds');
    const h = date.get('days') * 24 + date.get('hours');
    const m = date.get('minutes');
    const s = date.get('seconds');
    return `${h ? h + '小时' : ''}${m ? m + '分钟' : ''}${s ? s + '秒' : ''}`;
};

// 题型：1-单选题, 2-多选题, 3-判断题, 4-填空题, 5-综合题, 6-简答题, 7-不定项题
export const getQuestionType = (value: number): string => {
    switch (value) {
        case 1:
            return '单选题';
        case 2:
            return '多选题';
        case 3:
            return '判断题';
        case 4:
            return '填空题';
        case 5:
            return '综合题';
        case 6:
            return '简答题';
        case 7:
            return '不定项题';
        case 58:
            return '完型题';
        default:
            return '-';
    }
};

// 弹出内容的方法
export const popUpComprehensiveQuestionTitle = (title: string, copyState: boolean, key = '') => {
    let winParams = 'toolbar=0,location=0,directories=0,status=0,menubar=0,';
    winParams += 'scrollbars=0,resizable=0,width=800,height=600';

    const newWindow = window.open('', `gdtk-question-${key}`, winParams);
    newWindow!.document.open();
    if (newWindow && newWindow.document) {
        newWindow.document.write(
            `<html lang="zh">
                <head>
                    <title></title>
                    <style >
                        body{width:calc(100vw - 16px);user-select: ${copyState ? 'text' : 'none'} ;}
                        img{vertical-align: middle;}
                        p{word-break:break-all}
                        img {cursor: default;display: inline !important;max-width: 100%;min-height: 20px;min-width: 20px;pointer-events: none;}
                        p,h1,h2,h3,h4,h5,table,pre {margin: 10px 0;line-height: 1.5;}
                        blockquote {display: block;border-left: 8px solid #d0e5f2;padding: 5px 10px;margin: 10px 0;line-height: 1.4;font-size: 100%;background-color: #f1f1f1;}
                        code {display: inline-block;background-color: #f1f1f1;border-radius: 3px;padding: 3px 5px;margin: 0 3px;}
                        table {border-top: 1px solid #ccc;border-left: 1px solid #ccc;}
                        table td,
                        table th {border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;padding: 3px 5px;min-height: 30px;height: 30px;}
                        table th {border-bottom: 2px solid #ccc;text-align: center;background-color: #f1f1f1;}
                        p,li {white-space: pre-wrap;}
                        pre > code {display: block;padding: 10px;}
                        ul, ol {margin: 10px 0 10px 20px;}
                        input[type='checkbox'] {margin-right: 5px;}
                    </style>
                </head>
            <body>`
        );
        newWindow.document.write(title);
        newWindow.document.write('</body></html>');
    }
};

// 表格的兼容函数
export const delExcleFunction = () => {
    setTimeout(() => {
        try {
            // 移除不要的右击
            const parent = document.getElementsByClassName('x-spreadsheet-contextmenu')[0];
            const clist = parent.children;
            for (let index = 20; index > 0; index--) {
                if (index > 4) {
                    parent.removeChild(clist[index]);
                }
            }
            // 删除菜单上的功能
            const parentBtns = document.getElementsByClassName('x-spreadsheet-toolbar-btns')[0];
            const btns = parentBtns.children;
            const delIndex = [27, 26, 25, 24, 23, 22, 18, 8, 4, 2];
            delIndex.map(_ => parentBtns.removeChild(btns[_]));
        } catch (error) {
            console.log('~ line 103  ~ error', error);
        }
    }, 500);
};

/**
 * @description 生成upper-lower的随机数
 * @param upper 最小
 * @param lower 最大
 * @param frontier
 * @returns 数字
 */
export const randomNumber = (upper: number, lower: number, frontier = false) => {
    return Math.floor(Math.random() * (upper - lower + Number(!frontier))) + lower;
};

export const isQuestionDone = (userAnswer: IQuestionListItem['userAnswer']): boolean =>
    Boolean(
        userAnswer &&
            (userAnswer.userAnswer ||
                userAnswer.userAnswer === 0 ||
                userAnswer.userAnswerImagesList?.length ||
                userAnswer.excelAnswer ||
                userAnswer.userClozeAnswers?.filter(clozeAnswer => !!clozeAnswer.userAnswer)?.length)
    );

export const fillZero = (value: number) => (value < 10 ? `0${value}` : value);

/**
 * 将十六进制颜色转换为带透明度的RGBA颜色
 * @param hex - 原始十六进制颜色
 * @param alpha - 透明度 (0-1)
 * @returns 带透明度的RGBA颜色
 */
export const hexToRgba = (hex: string, alpha: number): string => {
    // 将十六进制颜色转换为RGB
    let newHex = hex.replace(/^#/, '');
    if (newHex.length === 3) {
        newHex = newHex
            .split('')
            .map(char => char + char)
            .join('');
    }
    const bigint = parseInt(newHex, 16);
    const rgb: [number, number, number] = [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];

    // 返回带透明度的RGBA颜色
    return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`;
};

export const getPresetsThemeColor = (themeString: string): { mainColor: string; secondaryColor: string } => {
    const theme = { mainColor: '', secondaryColor: '' };
    switch (themeString) {
        case 'green':
            theme.mainColor = '#35C25E';
            theme.secondaryColor = hexToRgba(theme.mainColor, 0.15);
            break;
        case 'blue':
            theme.mainColor = '#408CFF';
            theme.secondaryColor = hexToRgba(theme.mainColor, 0.15);
            break;
        case 'orange':
            theme.mainColor = '#FF6E00';
            theme.secondaryColor = hexToRgba(theme.mainColor, 0.15);
            break;
        default:
            theme.mainColor = '#FF6E00';
            theme.secondaryColor = hexToRgba(theme.mainColor, 0.15);
            break;
    }
    return theme;
};

export const downloadFile = (fileUrl: string, fileName?: string) => {
    // 浏览器支持fetch则用blob下载，避免浏览器点击a标签，跳转到新页面预览的行为
    if ((window as any).fetch) {
        fetch(fileUrl)
            .then(res => res.blob())
            .then(blob => {
                const newFileName = fileName || fileUrl.split('/').pop();
                const a = document.createElement('a');
                const url = window.URL.createObjectURL(blob);
                const aId = newFileName + '_' + +new Date();
                a.id = aId;
                a.href = url;
                a.download = newFileName || '附件文件';
                document.body.append(a); // 修复qq浏览器无法下载
                a.click();
                setTimeout(() => {
                    document.getElementById(aId) && a.remove(); // 修复qq浏览器无法连续下载
                }, 1000);
            })
            .catch(error => {
                message.error('下载失败请联系管理员');
            });
    } else {
        Modal.info({
            title: '浏览器不兼容，请复制下面链接自行下载，或联系学管，索要资料',
            content: fileUrl,
            width: 600,
            okText: '确定',
        });
    }
};

/**
 * 验证对象中指定键是否存在且具有有效值（非null/undefined/空字符串）
 *
 * @param obj - 待检查的源对象（泛型T约束为object类型）
 * @param keys - 需要验证的键名数组（必须是obj类型的合法键）
 * @returns 当且仅当所有键都存在且对应值不为null/undefined/空字符串时返回true
 *
 * @template T - 泛型类型参数，约束为object类型，确保类型安全
 */
export function areKeysPresentAndNonEmpty<T extends object>(obj: T, keys: (keyof T)[]): boolean {
    // 使用数组的every方法验证所有键是否满足以下条件：
    // 1. 键存在于对象中（hasOwnProperty检查）
    // 2. 值不为null
    // 3. 值不为undefined
    // 4. 值不为空字符串
    return keys.every(key => obj.hasOwnProperty(key) && obj[key] !== null && obj[key] !== undefined && obj[key] !== '');
}
